import PropTypes from "prop-types"
import React from "react"

import { formatCurrencyFromMinorUnits } from "src/utils/UnitConversion"

const BasicPrice = ({
  label,
  amount,
  description = null,
  dates = null,
  currency = "USD",
}) => {
  return (
    <div className="flex items-center justify-between">
      {description || dates ? (
        <div>
          <div>{label}</div>
          {description && (
            <div className="pl-2 text-sm text-gray-700">{description}</div>
          )}
          {dates && <div className="pl-2 text-sm text-gray-700">{dates}</div>}
        </div>
      ) : (
        <span>{label}</span>
      )}
      <span className="text-lg font-semibold text-gray-600">
        {formatCurrencyFromMinorUnits({ amount, currency })}
      </span>
    </div>
  )
}

BasicPrice.propTypes = {
  label: PropTypes.string.isRequired,
  amount: PropTypes.number.isRequired,
  description: PropTypes.string,
  dates: PropTypes.string,
  currency: PropTypes.string,
}

export default BasicPrice
